import {ZIDXFormFieldValue} from "./FormFieldValue.js";
import {ZIDXFormFieldType} from "./FormFieldType.js";

export class ZIDXFormField {
    name="";
    label="";
    help="";
    placeholder="";
    helpSuffix="";
    html="";
    custom="";
    values:ZIDXFormFieldValue[]=[]
    type:ZIDXFormFieldType=ZIDXFormFieldType.TEXT;
    required=false;
    multiple=false;
}